import { createFileRoute, redirect } from '@tanstack/react-router';

import { PortalToCrmEmailSyncIssuePage } from '~pages/payments/portal-crm-email-sync-issue';
import { UserRoles } from '~entities/users/model/types';
import { checkMinRoleValue } from '~shared/utils/role-guard';

const PendingComponent = () => (
  <div className='flex h-screen items-center justify-center'>Loading…</div>
);

export const Route = createFileRoute(
  '/_auth/_layout/payment/portal-crm-email-sync-issue',
)({
  beforeLoad: async () => {
    const hasAccess = await checkMinRoleValue(UserRoles.SUPER_ADMIN);
    if (!hasAccess) {
      throw redirect({ to: '/dashboard' });
    }
  },
  pendingComponent: PendingComponent,
  component: PortalToCrmEmailSyncIssuePage,
});
